import { studentBookingClient } from '../client';

import { RebookersEndpoints } from './constants';
import {
    GetIsValidRebookerProcessSuccessResponse,
    GetRebookerActiveProcessSuccessResponse,
    IsValidRebookerResponse,
} from './types';

export const getIsValidRebooker = async (roomCode: string): Promise<IsValidRebookerResponse> => {
    const { data: response } =
        await studentBookingClient.get<GetIsValidRebookerProcessSuccessResponse>(
            RebookersEndpoints.GetIsValidRebooker.replace('{roomCode}', roomCode)
        );

    return response.data;
};

export const getRebookerActive = async (roomCode: string): Promise<boolean> => {
    const { data: response } =
        await studentBookingClient.get<GetRebookerActiveProcessSuccessResponse>(
            RebookersEndpoints.GetRebookerActive.replace('{roomCode}', roomCode)
        );

    return response.data;
};
